<template>
<ItpBox
  direction="row"
  class="flex-fill"
>
  <div
    class="mr-3"
  >
    <Icon
      icon="ri:import-line"
      :tooltip="'Invoice import'|pgettext('Notification')"
    >
    </Icon>
  </div>
  <ItpBox
    direction="column"
    class="flex-fill"
  >
    <ItpBox
      direction="row"
    >
      <ItpText
        :text="'Invoice import'|pgettext('Notification')"
        small
        :title="notification.description"
      >
      </ItpText>
    </ItpBox>
    <ItpBox
      direction="row"
    >
      <ItpText
        :title="notification.data.company.name"
        strong
        :text="notification.data.company.name"
        class="mr-1"
        :style="b_1468474219929533_style"
      >
      </ItpText>
      <ItpLink
        :icon="$config.externalLinkIcon"
        :to="{
    name: 'app.company',
    params: {id: notification.data.company.id}
  }"
        v-if="notification.data.company.id"
      >
      </ItpLink>
      <span
        class="mx-2"
      >
        &middot;
      </span>
      <UcInvoiceKindBadge
        :value="notification.data.invoice_kind"
        v-if="notification.data.invoice_kind"
      >
      </UcInvoiceKindBadge>
      <ItpText
        strong
        :text="notification.data.invoice_number"
        class="mr-1"
      >
      </ItpText>
      <ItpLink
        :icon="$config.externalLinkIcon"
        :to="{
    name: 'app.invoice',
    params: {id: notification.key}
  }"
        v-if="notification.data.invoice_id"
      >
      </ItpLink>
      <span
        class="mx-2"
      >
        &middot;
      </span>
      <ItpText
        :title="notification.data.client.name"
        strong
        :text="notification.data.client.name"
        class="mr-1"
        :style="b_8385232899523842_style"
      >
      </ItpText>
      <ItpLink
        :icon="$config.externalLinkIcon"
        :to="{
    name: 'app.company',
    params: {id: notification.data.client.id}
  }"
        v-if="notification.data.client.id"
      >
      </ItpLink>
    </ItpBox>
    <DIV
      class="mt-1"
      v-if="notification.data.level === 'warning'"
    >
      <ItpBadge
        variant="warning"
        class="mr-2"
      >
        {{ notification.description }}
      </ItpBadge>
    </DIV>
  </ItpBox>
  <ItpBox
    class="align-self-center"
  >
    <ItpText
      small
      muted
      :title="notification.key"
    >
      {{ notification.created_at | datetime }}  {{ notification.created_by | username }}
<br/>

    </ItpText>
  </ItpBox>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceImportNotificationCard extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  notification!: object;

  @Watch('notification')
  onNotification(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("notification")
  }

  ux!: any;
  b_1468474219929533_style!: any;
  b_8385232899523842_style!: any;
  dataMembers = ['ux', 'b_1468474219929533_style', 'b_8385232899523842_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
        b_1468474219929533_style: {
          maxWidth: "200px",
        }
        ,
        b_8385232899523842_style: {
          maxWidth: "200px",
        }
        ,
      },
    }
  }

  get notificationType() {
    if (this.loaded) {

      return _.last(this.notification.type.split(':'))
    }
    return null;
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcInvoiceImportNotificationCard", UcInvoiceImportNotificationCard);

</script>